export default __webpack_public_path__ + "static/media/akamai.f653bff5.svg";